import React, { useEffect, useState } from 'react'
import AxiosAuth from '../../utility/AxiosAuth';
import ConfigApi from '../../utility/ConfigApi';
import InitInfo from '../../utility/InitInfo';
import { useTemplate } from '../../context/TemplateProvider';
import { useModal } from '../../context/ModalContext';
import { handleFormSubmit } from '../../utility/formHelpers';

  
function ProfitLossDisbursementInfo() {
    const {userId} = InitInfo();
    const [isLoading, setIsLoading] = useState(false)    
    const [year, setYear] = useState()
    const [disburseAr, setDisburseAr] = useState()
    const [profitAr, setProfitAr] = useState()
    const [profitLossAr, setProfitLossAr] = useState()
    const [error, setError] = useState(null)
    const {setMessage,setLoading,setHeaderText,reloadKey,setReloadKey}=useTemplate()
    const [accData, setAccData] = useState()

    const handleSubmit = async () => {
        if (userId && year>0) {
          setLoading(123);
          AxiosAuth.post(ConfigApi.PROFIT_LOSS_DISBURSE, {userId,year})
            .then(({data}) => {
              setLoading();
  
              if (data.error===0) {
                setDisburseAr(data.disburse_all_ar);  
                setProfitAr(data.dataAr);                  
                setAccData(data.acc_all_ar);
                setProfitLossAr(data.profit_loss_ar)
                setReloadKey(data.reloadKey)
              }else{
                setMessage({type: 'error', text: data.message})
              }
              
            })
            .catch(err => {
              console.log(err);
            });
        }
    };
    
    useEffect(()=>{
        setHeaderText('Profit Loss Disbursement Info ')
        if (userId && year>0) {
          setLoading(123);
          AxiosAuth.post(ConfigApi.PROFIT_LOSS_INFO, {userId,year})
            .then(({data}) => {
              setLoading();
  
              if (data.error===0) {
                setDisburseAr(data.disburse_all_ar);  
                setProfitAr(data.dataAr);                  
                setAccData(data.acc_all_ar);
                setProfitLossAr(data.profit_loss_ar)
              }else{
                setMessage({type: 'error', text: data.message})
              }
              
            })
            .catch(err => {
              console.log(err);
            });
        }
      },[year,reloadKey])

    let Sl=1;

    
    return (
      <div>
          <div className="relative overflow-x-auto sm:rounded-lg">
              <div className="pb-4 bg-white dark:bg-gray-900">
                  <label htmlFor="table-search" className="sr-only">Search</label>
                  <div className="flex items-center justify-between mt-1">
                      {/* Search Bar */}
                      <div className="relative">
                          <select onChange={(e)=>setYear(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option selected>Select Year</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                          </select>
                      </div>

                      {/* Add New Member Button */}
                      
                  </div>
              </div>
              <div className='flex mb-5'>
                <div class="max-w-sm p-6 me-5 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                    <a href="#">
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">Total Income</h5>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">{profitAr?.totalIncome}</h5>
                    </a>                  
                </div>
                <div class="max-w-sm p-6 me-5 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                    <a href="#">
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">Total Expense</h5>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">{profitAr?.totalExpense}</h5>
                    </a>                  
                </div>
                <div class="max-w-sm p-6 me-5 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                    <a href="#">
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">{(profitAr?.profitLoss>0?"Profit":"Loss")}</h5>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">{profitAr?.profitLoss}</h5>
                    </a>                  
                </div>
                {profitAr?.profitLoss?<div class="max-w-sm p-6 me-5 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                    <a href="#">
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">Deduct 2.5% Amount</h5>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">{profitAr?.twoPercent}</h5>                  
                    </a>                  
                </div>
                :""}
                
                {profitAr?.profitLoss?<div class="max-w-sm p-6 me-5 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                    <a href="#">
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">Disbursable Profit</h5>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">{profitAr?.disbursable}</h5>                  
                    </a>                  
                </div>
                :""}
                {profitAr?.profitLoss?<div class="max-w-sm p-6 me-5 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
                  {(profitLossAr?.sl?<span>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">Already Disburse</h5>
                    </span>:<span onClick={handleSubmit}>
                        <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white text-center">Disburse Now</h5>
                    </span>)}
                                    
                </div>
                :""}
                
              </div>
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                          <th scope="col" className="p-4">
                              SL
                          </th>

                          <th scope="col" className="px-6 py-3">
                              Join Date
                          </th>

                          <th scope="col" className="px-6 py-3">
                              Investor Name
                          </th>
                          
                          <th scope="col" className="px-6 py-3">
                              Balance
                          </th>
                        
                          <th scope="col" className="px-6 py-3">
                              Disburse Amount
                          </th>
                        
                      </tr>
                  </thead>
                  <tbody>
                      {accData && accData?.map((row)=>(
                      <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={row.sl}>
                          <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {Sl++}
                          </td>
                          <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              {row.joinDate}
                          </th>
                          <td className="px-6 py-4">
                              {row.name}
                          </td>
                          <td className="px-6 py-4">
                              {row.balance}
                          </td> 
                          <td>
                            {row?.disburse_amount}
                          </td>
                                                
                      </tr>
                      ))}
                  </tbody>
              </table>
          </div>
      </div>
    )
}

export default ProfitLossDisbursementInfo